import React from 'react';
import CameraForm from './CameraForm';
export default function AddCamera() {
  return <CameraForm />;
}
